export default __webpack_public_path__ + "static/media/icono1.11d23854.svg";